import { useState, useEffect } from 'react'
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Select from 'react-select'
import { checkboxData } from './checkboxData';
import './style.css'
import { useUserAuth } from '../../context/UserAuthContext';
import { useFormik } from 'formik';
import { floristTtkSchema } from '../schemas';
import axios from "axios";
import ThinksToKnowStatus from './ThinksToKnowStatus';

const FlorishTTK = () => {
    const [ttkEditMode, setTtkEditMode] = useState(false)
    const { user, language, token } = useUserAuth();
    const merchant_id = user.uid;
    const [merchant, setMerchant] = useState({});

    const base_url = import.meta.env.VITE_LOCAL_BASE_URL;
    const getSingleDocumentHandler = async () => {
        try {
            const res = await axios.get(
                `${base_url}/api/v1/thinkstoknow/${merchant_id}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
            );
            const data = res.data.data;
            const details = data[0].details;
            // const details = rawDetails ? JSON.parse(rawDetails) : null;
            if (details) {
                setMerchant(details);
                // formik.setValues(details);
            }
        } catch (error) {
            console.log(`Error : ${error}`);
        }
    };
    useEffect(() => {
        if (!merchant_id) return
        getSingleDocumentHandler()
    }, [merchant_id, token])

    const workingSinceOption = checkboxData.workSinceOption;
    const areaOfWorkingOption = checkboxData.areaOfWorking;
    const serviceOfferedOption = checkboxData.serviceOfferedFlorish;
    const planningTypeOption = checkboxData.planningTypeFlorish;
    const TravelPreferenceOption = checkboxData.travelPreferenceFlorish;

    const formik = useFormik({
        initialValues: {
            coverdofevents: merchant?.coverdofevents || '',
            travelPreference: merchant?.travelPreference || [],
            workingSince: merchant?.workingSince || [],
            serviceOffered: merchant?.serviceOffered || [],
            planningType: merchant?.planningType || [],
            areaOfWorking: merchant?.areaOfWorking || [],
        },
        enableReinitialize: true,
        validationSchema: floristTtkSchema,
        onSubmit: async (values) => {
            try {
                const data = {
                    id: merchant_id,
                    details: { ...values },
                };

                const res = await axios.post(`${base_url}/api/v1/thinkstoknow`, data, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });

                if (res.status === 201) {
                    toast.success("Things to know added successfully.");
                    setMerchant(values);
                    formik.setValues(values);
                    setTtkEditMode(false);
                } else if (res.status === 202) {
                    toast.success("Your update is pending approval by the admin.");
                    setTtkEditMode(false);
                } else {
                    toast.info(res.data.message || "Request submitted.");
                    setTtkEditMode(false);
                }

            } catch (error) {
                console.error(`Error ${error}`);
                toast.error('An error occurred while submitting the data.');
            }
        },
    });
    return (
        <div className="page-wrapper">
            <div className="container-fluid">
                 <ThinksToKnowStatus/>
                <div className='row'>
                    <div className='col-md-12'>
                        <div className='card'>
                            <div className='card-header bg-primary text-white'>
                                <h5> {language === 'en' ? 'Things to Know' : 'जानने योग्य जानकारी भरे'}</h5>
                            </div>
                            <div className='card-body'>
                                {
                                    merchant && (
                                        <>
                                            <div className='table-responsive'>
                                                <table className='table text-center' cellPadding={0} cellSpacing={0} style={{ border: '1px solid #fff ' }}>
                                                    <tbody className='ttk_preview'>
                                                        <tr style={{ color: '#41B0FA' }}>
                                                            <th style={{ width: '25%' }}>Working Since</th>
                                                            <th style={{ width: '25%' }}>Serving Cites</th>
                                                            <th style={{ width: '25%' }}>Services Offered</th>
                                                            <th style={{ width: '25%' }}>Coverd Of Events</th>

                                                        </tr>
                                                        <tr>
                                                            <td>{
                                                                merchant.workingSince?.map((item, index) => {
                                                                    return <span key={index}>{item.value}</span>
                                                                })
                                                            }</td>

                                                            <td>{
                                                                merchant.areaOfWorking
                                                                    ?.map((item, index) => {
                                                                        return <>
                                                                            <i className='fa fa-check text-success' />
                                                                            <span key={index}>{item.value} </span>
                                                                        </>
                                                                    })
                                                            }</td>

                                                            <td>{
                                                                merchant.serviceOffered
                                                                    ?.map((item, index) => {
                                                                        return <>
                                                                            <i className='fa fa-check text-success' />
                                                                            <span key={index}>{item.value} </span>
                                                                        </>
                                                                    })
                                                            }</td>
                                                            <td> {merchant.coverdofevents}</td>



                                                        </tr>
                                                        <tr style={{ color: '#41B0FA' }}>


                                                            <th>Planning Type</th>
                                                            <th>Travel Preference</th>

                                                        </tr>
                                                        <tr>
                                                            <td>{
                                                                merchant.planningType
                                                                    ?.map((item, index) => {
                                                                        return (
                                                                            <>
                                                                                <i className='fa fa-check text-success' />
                                                                                <span key={index}>{item.value} </span>
                                                                            </>
                                                                        )
                                                                    })
                                                            }</td>

                                                            <td>{
                                                                merchant.travelPreference
                                                                    ?.map((item, index) => {
                                                                        return (
                                                                            <>
                                                                                <i className='fa fa-check text-success' />
                                                                                <span key={index}>{item.value} </span>
                                                                            </>
                                                                        )
                                                                    })
                                                            }</td>

                                                        </tr>
                                                    </tbody>
                                                </table>

                                            </div>
                                        </>
                                    )
                                }
                                <center >
                                    <button className='btn btn-primary mb-2' onClick={() => setTtkEditMode(!ttkEditMode)}>{`${merchant ? 'Make Changes' : 'Tell me more about yourself'}`}</button>
                                </center>
                                {
                                    ttkEditMode && (
                                        <form onSubmit={formik.handleSubmit}>
                                            <div className='row'>
                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>Working Since <span className='text-danger'>*</span></label>
                                                        <Select
                                                            closeMenuOnSelect={false}
                                                            isMulti
                                                            options={workingSinceOption}
                                                            selected
                                                            value={formik.values.workingSince}
                                                            onChange={(workingSince) => formik.setFieldValue('workingSince', workingSince)}
                                                            onBlur={formik.handleBlur}
                                                        />
                                                        {formik.touched.workingSince && formik.errors.workingSince ? (
                                                            <div className="text-danger">{formik.errors.workingSince}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>Serving Cities</label>
                                                        <Select
                                                            closeMenuOnSelect={false}
                                                            isMulti
                                                            options={areaOfWorkingOption}
                                                            selected
                                                            value={formik.values.areaOfWorking}
                                                            onChange={(areaOfWorking) => formik.setFieldValue('areaOfWorking', areaOfWorking)}
                                                            onBlur={formik.handleBlur}
                                                        />
                                                        {formik.touched.areaOfWorking && formik.errors.areaOfWorking ? (
                                                            <div className="text-danger">{formik.errors.areaOfWorking}</div>
                                                        ) : null}
                                                    </div>
                                                </div>


                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>Services Offered</label>
                                                        <Select
                                                            closeMenuOnSelect={false}
                                                            isMulti
                                                            options={serviceOfferedOption}
                                                            selected
                                                            value={formik.values.serviceOffered}
                                                            onChange={(serviceOffered) => formik.setFieldValue('serviceOffered', serviceOffered)}
                                                            onBlur={formik.handleBlur}
                                                        />
                                                        {formik.touched.serviceOffered && formik.errors.serviceOffered ? (
                                                            <div className="text-danger">{formik.errors.serviceOffered}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>Coverd of Events</label>
                                                        <input type='number' placeholder='Coverd Of Events' className='form-control' name="coverdofevents" onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.coverdofevents} />
                                                        {formik.touched.coverdofevents && formik.errors.coverdofevents ? (
                                                            <div className="text-danger">{formik.errors.coverdofevents}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>Planning Type</label>
                                                        <Select
                                                            closeMenuOnSelect={false}
                                                            isMulti
                                                            options={planningTypeOption}
                                                            selected
                                                            value={formik.values.planningType}
                                                            onChange={(planningType) => formik.setFieldValue('planningType', planningType)}
                                                            onBlur={formik.handleBlur}
                                                        />
                                                        {formik.touched.planningType && formik.errors.planningType ? (
                                                            <div className="text-danger">{formik.errors.planningType}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>Travel Preference</label>
                                                        <Select
                                                            closeMenuOnSelect={false}
                                                            isMulti
                                                            options={TravelPreferenceOption}
                                                            selected
                                                            value={formik.values.travelPreference}
                                                            onChange={(travelPreference) => formik.setFieldValue('travelPreference', travelPreference)}
                                                            onBlur={formik.handleBlur}
                                                        />
                                                        {formik.touched.travelPreference && formik.errors.travelPreference ? (
                                                            <div className="text-danger">{formik.errors.travelPreference}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='form-group'>
                                                <button className='btn btn-primary' type='submit'>Submit</button>
                                            </div>
                                        </form>
                                    )
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default FlorishTTK